import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useParams } from "react-router-dom";
import Navbar from "./components/Navbar";
import Contact from "./pages/ContactUs"
import About from "./pages/AboutUs"
import Home from "./pages/Homepage";
import Footer from "./components/Footer";
import Services from "./pages/Services";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../src/App.css"
import { HelmetProvider } from "react-helmet-async";
import CookiesPolicy from './pages/CookiesPolicy';
import Help from './pages/Help';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import HolidaysPackages from './pages/HolidaysPackages';
import DestinatonPackages from './pages/DestinatonPackages';
import PackagesDetails from './pages/PackagesDetails';
import { Packages } from './data/Destination';
import GroupPackages from "./pages/GroupPackages";
import GroupTourAllPackages from "./pages/GroupTourAllPackages";
import GroupTourPackagesDetails from "./pages/GroupTourPackageDetails";

function App() {
  const { slug } = useParams();
  // eslint-disable-next-line
  const data = Packages?.find((d) => d?.slug?.includes(slug));
  return (
    <>
      <HelmetProvider>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/packages" element={<HolidaysPackages />} />
            <Route path="/group-tour/" element={<GroupTourAllPackages />} />
            <Route path="/group-tour/:slug" element={<GroupPackages />} />
            <Route path="/group-tour/:slug/:slug" element={<GroupTourPackagesDetails />} />
            <Route path="/packages/:slug" element={<DestinatonPackages />} />
            <Route path="/packages/:slug/:slug" element={<PackagesDetails />} />
            <Route path="/cookiesPolicy" element={<CookiesPolicy />} />
            <Route path="/help" element={<Help />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/termsconditions" element={<TermsConditions />} />
          </Routes>
          <Footer />
        </Router>
      </HelmetProvider>
    </>
  );
}

export default App;
